module.exports = __webpack_public_path__ + "5cc1857e602c0d9abad65e732a1afc5c.MP3";